import React from 'react';
import Zoom from 'react-reveal/Zoom';
import Spin from 'react-reveal/Spin';
import { Link } from 'react-router-dom';

const TitleSection = () => {
  return (
    
    <section className="colored-section" id="title">
      <div className="container-fluid">
        {/* Title */}
        <div className="row">
          <Zoom>
          <div className="col-lg-6">
          
          <h1 className="big-heading"> 🩺REBOUNCE!</h1>
            <h1 >Bounce Back to Your
               Active Life</h1>
               
               <a className="btn btn-light btn-lg download-button" href="tel:6300824320">
  <i  aria-hidden="true"></i> 📞Call Now
</a>
    
      
<Link to="/book-appointment">
                <div className="btn btn-info btn-lg download-button">
                  <i></i> 👨‍⚕️Book Appointment
                </div>
              </Link>
            
          </div>
          </Zoom>
          <Spin>
          <div className="col-lg-6">
            <img className="title-image" src={require('./phylogo.png')} alt="iphone-mockup" />
          </div>
          </Spin>
        </div>
      </div>
    </section>
  );
};

export default TitleSection;